import { ButtonRoot } from '@/components/common/Button'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type CardRefType } from '@/defs/card'
import { CLIPBOARD_CARD_STATUS_LABELS } from '@/defs/clipboard'
import { useClipboardButton } from '@/hooks/useClipboardButton'
import { cn } from '@/utils/commonUtil'

import styles from '../../CardControls.module.scss'

type Props = {
  cardRef: CardRefType
}

export const CardControlsClipboardOption = ({ cardRef }: Props) => {
  const { isAllInClipboard, onToggleAllClick } = useClipboardButton({ cardRefs: [cardRef] })

  const status = isAllInClipboard ? 'saved' : 'unsaved'
  const { actionLabel, icon } = CLIPBOARD_CARD_STATUS_LABELS[status]
  const colorScheme = isAllInClipboard ? 'success' : undefined

  return (
    <ButtonRoot
      aria-label={`${actionLabel}: ${cardRef.name}`}
      className={cn(styles.option, { colorScheme, styles })}
      onClick={onToggleAllClick}
    >
      <IconWithLabel iconBefore={icon} iconBeforeSize='sm'>
        {cardRef.name}
      </IconWithLabel>
    </ButtonRoot>
  )
}
